import React, { useContext } from 'react';
import { ProductExportConfigurationContext } from '../../../../../../context/ProductExportConfigurationContext';
import { ExportConfigurationsPane } from '../../../../../components/ExportItems';

export default function ProductExportConfigurationSettingsPane() {
  const { productExportConfigurations, productExportConfigurationsLoading } = useContext(
    ProductExportConfigurationContext,
  );

  return (
    <ExportConfigurationsPane
      configurations={[...productExportConfigurations.values()]}
      loading={productExportConfigurationsLoading}
    />
  );
}
